import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import CardMoreButton from '@/components/CardMoreButton.vue';

var NoScheduleCard = /*#__PURE__*/function (_Vue) {
  _inherits(NoScheduleCard, _Vue);

  var _super = _createSuper(NoScheduleCard);

  function NoScheduleCard() {
    _classCallCheck(this, NoScheduleCard);

    return _super.apply(this, arguments);
  }

  _createClass(NoScheduleCard, [{
    key: "onSchedule",
    value: function onSchedule() {
      this.$router.push("/index/scheduleCreate/".concat(this.info.caseIndexCode));
    }
  }, {
    key: "onDeleteCaseSuccess",
    value: function onDeleteCaseSuccess() {}
  }, {
    key: "showPlaintiffName",
    // 原告姓名
    get: function get() {
      return this.info.plaintiffs.join(' ');
    } // 被告姓名

  }, {
    key: "showDefendantName",
    get: function get() {
      return this.info.defendants.join(' ');
    } // 当事人姓名

  }, {
    key: "showPartyName",
    get: function get() {
      return this.info.partyList.map(function (val) {
        return val.partyName;
      }).join(' ');
    } // 代理人姓名

  }, {
    key: "showProcuratorName",
    get: function get() {
      return this.info.procuratorList.map(function (val) {
        return val.procuratorName;
      }).join(' ');
    } // 第三人姓名姓名

  }, {
    key: "showThirdName",
    get: function get() {
      return this.info.thirds.join(' ');
    }
  }, {
    key: "showNameMap",
    get: function get() {
      return this.$store.getters.showNameMap;
    }
  }, {
    key: "isArbitration",
    get: function get() {
      return this.$store.getters.tribunalType === 'arbitration';
    }
  }]);

  return NoScheduleCard;
}(Vue);

__decorate([Prop({
  required: true
})], NoScheduleCard.prototype, "info", void 0);

__decorate([Emit('schedule')], NoScheduleCard.prototype, "onSchedule", null);

__decorate([Emit('onDeleteCaseSuccess')], NoScheduleCard.prototype, "onDeleteCaseSuccess", null);

NoScheduleCard = __decorate([Component({
  components: {
    CardMoreButton: CardMoreButton
  }
})], NoScheduleCard);
export default NoScheduleCard;